import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import useCadastroMotivoBloqueioPosicaoEstoque, {
  LOAD_MESSAGE,
} from './CadastroMotivoBloqueioPosicaoEstoqueHook'
import ModalCadastroMotivoBloqueioPosicaoEstoque from './ModalCadastroMotivoBloqueioPosicaoEstoque/ModalCadastroMotivoBloqueioPosicaoEstoque'

function CadastroMotivoBloqueioPosicaoEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useCadastroMotivoBloqueioPosicaoEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET_MOTIVOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMotivosBloqueio(selectedTp)
        break
      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteMotivoBloqueio(selectedTp, state.selectedOperacao)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>8.15 - Cadastro de Motivo de Bloqueio de Posição Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.toggleModal(true, null)}
          onVoltar={history.goBack}
          showBtnNovo={!!selectedTp}
        >
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-12">
              <DataTable
                value={state.motivos}
                emptyMessage="Não existe motivo de bloqueio cadastrado."
              >
                <Column field="id" header="Código" style={tableCellCentered()} />
                <Column field="name" header="Nome" />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={motivo => (
                    <ThreeDots
                      items={['1. Apagar']}
                      onClick={item => localDispatch.onMenuItemClicked(item, motivo)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCadastroMotivoBloqueioPosicaoEstoque
        onModalSave={localDispatch.onModalSave}
        onError={error => dispatch(showMessageBox(null, error))}
        tpId={selectedTp}
        onModalClose={() => localDispatch.toggleModal(false, null)}
        selectedMotivo={state.selectedMotivo}
        visible={state.showModal}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroMotivoBloqueioPosicaoEstoque))
